// Module Import
//---------------------------------
import React from 'react'
import styled from 'styled-components'
import ImageCut from '../../../assets/images/graphic_imageCut.svg'
import TextHeader from '../TextHeader/TextHeader'
import LinkAtom from '../../atoms/links/links'
import {brandDarkGrey, brandGrey, brandIvory, brandOrange} from '../../../assets/consts/color'

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------
const PageSummaryWrapper = styled.section`
  position: relative;
`

const PageSummaryList = styled.ul`
  list-style: none;
  padding: 0;
`

const PageSummaryListItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0 0 24px 0;
  @media only screen and (min-width: 90em) {
    margin: 0;
    &:not(:last-child) {
      border-right: 4px solid ${brandOrange};
    }
  }
`
const CopyWrapper = styled.div`
  background-color: ${(props) => props.variant === "primary" ? brandIvory : "none"};
  border-bottom: ${(props) => props.variant === "primary" ? "2px solid #00000012" : "none"};
  border-radius: 4px;
  display: flex;
  flex: 1 1 0%;
  flex-direction: column;
  margin: 0;
  padding: ${(props) => props.variant === "primary" ? "40px 48px" : "8px"};
  position: relative;

  &:after {
    display: ${(props) => props.variant === "primary" ? "block" : "none"};
    background-image: url(${ImageCut});
    background-position: top left;
    background-size: cover;
    content: '';
    height: 30px;
    left: 0;
    position: absolute;
    top: 0;
    transform: rotate(-180deg);
    width: 30px;
    z-index: 1;
  }

  h4 {
    margin: 0 0 8px 0;
    font-weight: bold;
    color:  ${(props) => props.variant === "primary" ? brandOrange : brandDarkGrey};
  }

  p {
    margin: 0;
  }
`

const Divider = styled.div`
  width: 4px;
  height: 100%;
  background: ${brandOrange};
`

// Component Export
//---------------------------------
export default function PageSummary({
  title,
  subtitle,
  cardOneTitle,
  cardOneBody,
  cardTwoTitle,
  cardTwoBody,
  cardThreeTitle,
  cardThreeBody,
  linkDestination,
  linkText,
  hasButton,
  fieldsNames = {},
  variant = "primary"
}) {
  return (
    <PageSummaryWrapper>
      <div className={`outer ${variant === "primary" ? "margin-160" : ""}`}>
        <div className="inner">
          {title === null ? null : (
            <TextHeader
              titleField={fieldsNames.title}
              subtitleField={fieldsNames.subtitle}
              title={title}
              subtitle={subtitle}
            />
          )}
          <PageSummaryList className="row ">
            <PageSummaryListItem className="col-xs-12 col-md-6 col-lg-4">
              <CopyWrapper variant={variant}>
                <h4>{cardOneTitle}</h4>
                <p>{cardOneBody}</p>
              </CopyWrapper>
            </PageSummaryListItem>
            <PageSummaryListItem className="col-xs-12 col-md-6 col-lg-4">
              <CopyWrapper variant={variant}>
                <h4>{cardTwoTitle}</h4>
                <p>{cardTwoBody}</p>
              </CopyWrapper>
            </PageSummaryListItem>
            <PageSummaryListItem className="col-xs-12 col-md-6 col-lg-4">
              <CopyWrapper variant={variant}>
                <h4>{cardThreeTitle}</h4>
                <p>{cardThreeBody}</p>
              </CopyWrapper>
            </PageSummaryListItem>
          </PageSummaryList>
          {/* Link logic */}
          {hasButton === true ? (
            <LinkAtom
              linkType="Simple Button Link"
              linkDestination={linkDestination}
              linkText={linkText}
            />
          ) : null}
        </div>
      </div>
    </PageSummaryWrapper>
  )
}

PageSummary.propTypes = {}
